// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"PebblePagination_paginationWrapper__lDMgr","paginationButtons":"PebblePagination_paginationButtons__KFiuR"};